import { XML_AddSingle } from "./XML_AddSingle";
import { XML_ScaleAndShiftX } from "./XML_ScaleAndShiftX";
import { XML_ScaleAndShiftY } from "./XML_ScaleAndShiftY";
import { XML_Scale } from "./XML_Scale";
import { XML_Cmd4 } from "./XML_Cmd4";
import { XML_Param4 } from "./XML_Param4";
import { RoundTo3 } from "./RoundTo3.js";

export function XML_FillRectPPT(x, y, width, height, fillColor, fillColor2, drawElement, layer) {
  x = XML_ScaleAndShiftX(x, drawElement, layer);
  y = XML_ScaleAndShiftY(y, drawElement, layer);
  width = XML_Scale(width, drawElement, layer);
  height = XML_Scale(height, drawElement, layer);
  //y = drawElement.ConvertY(y);
  //y = y - height;
  XML_Cmd4("rec", RoundTo3(x), RoundTo3(y), RoundTo3(width), RoundTo3(height), drawElement);
  //Fill color, border color, border thickness, border dash
  XML_Param4("p", fillColor, "#FFFFFF", 0, 0, drawElement);
  if (fillColor2 != null) {
    XML_AddSingle(fillColor2, "grd", drawElement);
  }
}
